import animatedScrollTo from 'scrollto-with-animation';

class NavBar {
  constructor($element) {
    this.$element = $element;
    this.initEvents();
  }

  get $hamburguer() {
    return this.$element.querySelector('.navbar-burger');
  }

  get $navbarItems() {
    return this.$element.querySelectorAll('.navbar-item');
  }

  initEvents() {
    if (this.$hamburguer) {
      this.$hamburguer.addEventListener('click', () => {
        const $target = document.getElementById(this.$hamburguer.dataset.target);

        this.$hamburguer.classList.toggle('is-active');
        $target.classList.toggle('is-active');
      });
    }

    if (this.$navbarItems) {
      [].map.call(this.$navbarItems, ($navbarItem) => {
        $navbarItem.addEventListener('click', (e) => {
          const $target = document.getElementById(e.target.getAttribute('href').replace('#',''));
          const targetPosition = ($target) ?
            $target.offsetTop :
            0;

          e.preventDefault();
          animatedScrollTo(
            document.scrollingElement, // element to scroll with (most of times you want to scroll with whole <body>)
            'scrollTop',
            targetPosition, // target scrollY (0 means top of the page)
            600, // duration in ms
            'easeOutExpo',
            function() { // callback function that runs after the animation (optional)
            }
          );
        });
      });
    }
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./js/components/navbar/navbar.js